<template>
   <div class="tool-selector" @click="$emit('click', tool)">
      <div class="tool-title">
         <svg-icon :url="tool.iconURL"/>
         <span>{{ tool.title }}</span>
      </div>
      <p>{{ tool.description }}</p>
   </div>
</template>

<script>
import SvgIcon from '@/components/atoms/Home/SvgIcon';

export default {
   components: {
      SvgIcon,
   },
   props: {
      tool: {
         type: Object,
         required: true,
         validator: tool => tool.title && tool.iconURL && tool.description,
      },
   },
}
</script>

<style lang="scss" scoped>
.tool-selector {
   cursor: pointer;
   color: $font-color;
   padding: 8px;
   transition: 0.3s;
   &:hover {
      background: rgba($primary-color,0.08);
   }
   
   .tool-title {
      display: flex;
      align-items: center;
      padding: 2px;
      span {
         font-family: $secondary-font;
         margin-left: 6px;
         font-weight: 500;
      }
   }
   p {
      padding: 3px;
      font-size: 14px;
      font-family: $primary-font;
      line-height: 1.6em;
   }
}
</style>